import { SIDEBAR_SECTIONS, HIDE_OUTBOUND_ICON_SECTIONS } from "../../constants";
import { WHATSAPP_BASE_URL } from "../../constants";
import { checkIsStringEmpty } from "features/Common/modules/DataTypes/Strings.utils";
import { checkIsArrayEmpty } from "features/Common/modules/DataTypes/utils/Array.utils";

export const getWhatsappUrl = ({ countryCode = "", phoneNumber = "" }) => {
  if (checkIsStringEmpty(countryCode) || checkIsStringEmpty(phoneNumber)) {
    return "";
  }

  return `${WHATSAPP_BASE_URL}${countryCode.replace("+", "")}${phoneNumber}`;
};

export const hasOutboundIcon = ({ sectionKey, isTitleChecked, isVisible }) => {
  const sectionConfig = SIDEBAR_SECTIONS?.[sectionKey];

  if (!sectionConfig) return false;

  if (isVisible === false) return false;

  if (HIDE_OUTBOUND_ICON_SECTIONS.includes(sectionKey)) return false;

  if (sectionConfig?.isWhitelabelFeature === false) return false;

  return Boolean(isTitleChecked?.[sectionKey]);
};

export const handleVisibilityToggle = async ({
  currentVisible,
  setVisible,
  miscellaneousData,
  sectionKey,
  sectionType,
  currentSectionName,
  fetchMiscellaneousData,
  createMutation,
  updateMutation,
  currentData = [],
}) => {
  if (createMutation.isLoading || updateMutation.isLoading) return;

  const nextVisible = !currentVisible;
  setVisible((prev) => !prev);

  try {
    const existingArray = miscellaneousData?.[sectionKey];

    const existingRecord = checkIsArrayEmpty(existingArray)
      ? null
      : existingArray[0];

    const uuid = existingRecord?.uuid;

    if (checkIsStringEmpty(uuid)) {
      // Create new record
      const payload = {
        type: sectionType,
        data: {
          section_name: currentSectionName,
          visible: nextVisible,
          data: currentData || [],
        },
      };

      await createMutation.mutateAsync(payload);

      // Refetch miscellaneous data after creation
      fetchMiscellaneousData({ type: sectionType });
      return;
    }

    // Update existing record
    const payload = {
      uuid,
      updated_values: {
        data: {
          ...(existingRecord?.data || {}),
          section_name: currentSectionName,
          visible: nextVisible,
          data: currentData || [],
        },
      },
    };

    await updateMutation.mutateAsync(payload);

    await fetchMiscellaneousData({ type: sectionType });

    if (checkIsArrayEmpty(existingArray)) {
      return;
    }
  } catch (err) {
    // rollback on failure
    setVisible((prev) => !prev);
  }
};
